const en = {
  today: 'YOUR DAY', planning: 'NEXT IN YOUR PLAN', complete: 'BRING THE STORY HOME',
  progress: '{{done}} of {{total}} stops visited', onMap: 'Show on map', openDay: 'Open day',
  completeTitle: 'The trip ends. The story stays.', completeBody: 'Keep your favourite moments and settle the shared costs.',
  story: 'Open the story', costs: 'Review costs',
  emptyTitle: 'Leave room for a good first stop.', emptyBody: 'Open the day to add a place or find something along the way.',
  dayDone: 'This day is yours to enjoy.', dayDoneBody: 'The planned stops are complete. Keep a moment or open the rest of the plan.',
  changed: 'This stop or day has changed. The available day plan is shown instead.',
};
const tr: Record<keyof typeof en, string> = {
  today: 'BUGÜNÜN', planning: 'PLANINDA SIRADAKİ', complete: 'HİKÂYEYİ EVE GETİR',
  progress: '{{total}} duraktan {{done}} tanesi gezildi', onMap: 'Haritada göster', openDay: 'Günü aç',
  completeTitle: 'Gezi biter. Hikâye kalır.', completeBody: 'Sevdiğin anları sakla, ortak masrafları tamamla.',
  story: 'Hikâyeyi aç', costs: 'Masraflara bak',
  emptyTitle: 'İlk güzel durağa yer aç.', emptyBody: 'Bir yer eklemek veya yol üstünde bir şey bulmak için günü aç.',
  dayDone: 'Bu günün tadını çıkar.', dayDoneBody: 'Plandaki duraklar tamamlandı. Bir anı sakla veya planın devamını aç.',
  changed: 'Bu durak veya gün değişmiş. Yerine mevcut gün planı gösteriliyor.',
};
const sv: Record<keyof typeof en, string> = {
  today: 'DIN DAG', planning: 'NÄSTA I DIN PLAN', complete: 'TA MED BERÄTTELSEN HEM',
  progress: '{{done}} av {{total}} stopp besökta', onMap: 'Visa på kartan', openDay: 'Öppna dagen',
  completeTitle: 'Resan tar slut. Berättelsen stannar.', completeBody: 'Spara dina favoritögonblick och gör upp de gemensamma kostnaderna.',
  story: 'Öppna berättelsen', costs: 'Se kostnader',
  emptyTitle: 'Gör plats för ett fint första stopp.', emptyBody: 'Öppna dagen för att lägga till en plats eller hitta något längs vägen.',
  dayDone: 'Njut av resten av dagen.', dayDoneBody: 'De planerade stoppen är klara. Spara ett ögonblick eller öppna resten av planen.',
  changed: 'Stoppet eller dagen har ändrats. Den tillgängliga dagsplanen visas i stället.',
};
export const agendaTranslations = { en, tr, sv };
